import React, { FC, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import { createGlobalStyle } from 'styled-components';
import { typeofService } from '../../utils/helpers/observer';
import { LocalStorage } from '../../utils/localStorage';
import IconComponent from '../common/component/IconComponent';
import File from '../../assets/Menu/file.svg';
import Graph from '../../assets/Menu/graphs.svg';

type option = {
  id: number;
  value: string;
  label: string;
  automatedTestId?: string;
  show?: boolean;
};
type NavListProps = {
  upperBlock: Array<option>;
  downBlock: Array<option>;
  adminBlock: Array<option>;
  collectionPoolBlock: Array<option>;
  selectedValue?: option | null;
};
const ModulesMenu: FC<NavListProps> = ({
  upperBlock,
  downBlock,
  adminBlock,
  collectionPoolBlock,
}) => {
  const roles = LocalStorage.userRole.get();
  const navigate = useNavigate();
  const location = useLocation();
  const found = [...upperBlock, ...downBlock, ...adminBlock, ...collectionPoolBlock].find(
    (item) => item.value === location.pathname
  );
  const [_selectedValue, setSelectedValue] =
    useState<option | null>(found || upperBlock[0]);
  const handleOnChange = (v: option) => {
    setSelectedValue(v);
    navigate(v.value);
    let module = '';
    if (v.label === 'H2S') {
      module = 'h2s';
    } else if (v.label === 'ECP') {
      module = 'ecp';
    } else if (v.label === 'DO-TP') {
      module = 'do';
    } else if (v.label === 'PR-MR') {
      module = 'pr';
    } else if (v.label === 'INDUS') {
      module = 'indus';
    } else if (v.label === 'MILIEU') {
      module = 'milieu';
    } else if (v.label === 'PLUIE') {
      module = 'pluie';
    } else if (v.label === 'HYDRO') {
      module = 'hydro';
    } else if (v.label === 'Administration') {
      module = 'administration';
    } else {
      module = 'collectionPool';
    }
    LocalStorage.type.set(module);
    typeofService.setType(module);

    // delete memory filters for this specific case
    if (v.label !== 'INDUS') {
      window.sessionStorage.setItem(
        'indus_section',
        JSON.stringify({
          name: '',
          code: '',
        })
      );
      window.sessionStorage.setItem(
        'indus_activity',
        JSON.stringify({
          name: '',
          code: '',
        })
      );
    }
  }

  // render of breakline
  const breakLine = () => {
    return (
      <hr
        style={{
          backgroundColor: '#1156B2',
          border: 'none',
          outline: 'none',
          width: '205px',
          height: '2px',
          margin: '2px 0',
        }}
      />
    );
  };

  const renderBlock = (pValues: any[], iconMode: string) => {
    const icon = iconMode === 'file' ? File : Graph;
    return pValues.map((value: any, index: number) => {      
      return (
        <div key={value.id}>
          {value.show && (
            <div
              className={`navElement-list-item ${(_selectedValue && _selectedValue.id === value.id) ? 'selected' : 'unselected'}`}
              id={value.automatedTestId}
            >
              <IconComponent
                id={index}
                icon={icon}
                divStyles={{
                  display: 'inline-flex',
                  alignSelf: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  margin: '10px',
                  width: '205px',
                  color: 'white',
                }}
                imgStyles={{
                  marginRight: '10px',
                }}
                titleStyles={{
                  fontSize: '14px',
                }}
                title={value.label}
                event={() => {
                  handleOnChange(value);
                }}
              />
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <Container>
      <Styles />
      <Container>
        {/* Block uppder */}
        {renderBlock(upperBlock, 'file')}
        {breakLine()}
        {/* Block middle */}
        {renderBlock(downBlock, 'icon')}
        {collectionPoolBlock[0].show === true ? breakLine() : null}
        {/* Block summarized */}
        {renderBlock(collectionPoolBlock, 'icon')}
        {roles?.includes('diagperm-admin') && breakLine()}
        {/* Block admin */}
        {renderBlock(adminBlock, 'icon')}
      </Container>
    </Container>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
  .navElement-list-item {
    width: 205px;
    border-radius: 10px;
    .sds-word {
        color: white;
      }
    &:hover {
      background-color: red;
    }
    &.selected {
      background-color: #1156B2;
      .sds-word {
        color: white;
      }
    }
    &.unselected {
      background-color: transparent;
    }
  }
 }
`;
export default ModulesMenu;
